__turbopack_context__.v({
  "className": "space_mono_bf363db-module__74UaaG__className",
  "variable": "space_mono_bf363db-module__74UaaG__variable",
});
